import React, { useState, useEffect } from 'react';
import BaseModal from 'components/Modal';
import { SearchInput } from '@spins/react-ui-library';
import { BrandType } from 'utils/types';
import { titleCase } from 'utils/functions';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import InfiniteScroll from 'react-infinite-scroll-component';
import LoadingSpinner from 'components/LoadingSpinner';
import { Alert } from 'react-bootstrap';
import _ from 'lodash';
import './styles.scss';

interface Props {
  brands: Array<BrandType>;
  show: boolean;
  onBrandSelection(brand: BrandType): void;
  onClose(): void;
}

const BrandPickerModal: React.FC<Props> = ({ brands, show, onBrandSelection, onClose }) => {
  const [searchText, setSearchText] = useState('');
  const [loadMore, setLoadMore] = useState(0);
  const [rows, setRows] = useState([]);

  const getRows = () => {
    const end = loadMore * 15 + 15;
    setTimeout(() => {
      setRows(_.orderBy(brands, ['name'], ['asc']).slice(0, end));
    }, 1000);
    setLoadMore(loadMore + 1);
  };

  const filteredBrands = _.orderBy(
    brands.filter(
      brand => searchText === '' || brand.name.toLowerCase().indexOf(searchText.toLowerCase()) > -1
    ),
    ['name'],
    ['asc']
  );

  const renderBrands = () => {
    if (searchText !== '') {
      return filteredBrands;
    } else {
      return rows;
    }
  };

  const handleClose = () => {
    setSearchText('');
    onClose();
  };

  useEffect(() => {
    if (loadMore === 0 && rows.length === 0 && brands.length > 0) {
      getRows();
    }
  });

  return (
    <BaseModal
      baseClassName="portfolio-brand-picker-modal"
      show={show}
      title="Select a Brand"
      onClose={handleClose}
    >
      <div className="pbpm-content">
        <SearchInput
          className="pbpm-search-field"
          placeholder="Search brands"
          onChange={text => setSearchText(text)}
        />
        <div className="items-container">
          <InfiniteScroll
            dataLength={rows.length}
            next={getRows}
            hasMore={rows.length < filteredBrands.length}
            height={340}
            loader={<LoadingSpinner />}
          >
            {renderBrands().length > 0 ? (
              renderBrands().map(brand => {
                return (
                  <div key={brand.name} className="item-container">
                    <Button onClick={() => onBrandSelection(brand)}>
                      <span className="img-container" />
                      <span className="brand-title">{titleCase(brand.name)}</span>
                      <FontAwesomeIcon className="icon" icon={faAngleRight} />
                    </Button>
                  </div>
                );
              })
            ) : (
              <Alert variant="warning">No data for the searched term</Alert>
            )}
          </InfiniteScroll>
        </div>
      </div>
    </BaseModal>
  );
};

export default BrandPickerModal;
